import { Company } from 'types/company';
import { Location } from 'types/location';
import { Place } from 'types/place';
import { Employee } from 'types/employee';
import { Menu } from 'types/menu';
import { Meta } from 'types/meta';
import { Review } from 'types/review';

export const initialCompany = (): Company => ({
  hash: '',
  country_code: '',
  facebook_pixel: '',
  translations: {},
  social_networks: [],
  locations: [],
  menu: initialMenu(),
  additional_questions: []
});

export const initialLocation = (): Location => ({
  hash: '',
  tip_available: false,
  translations: {},
  review_mechanics: 'simple',
  location_rating_links: [],
  social_networks: [],
  company: initialCompany(),
  menu: initialMenu(),
  additional_questions: [],
  actions: [],
  places: [],
  contacts_required: 'flexible'
});

export const initialPlace = (): Place => ({
  hash: '',
  translation: {},
  company: initialCompany(),
  location: initialLocation()
});

export const initialMeta = (): Meta => ({
  default_locale: '',
  color: '#000000',
  locales: [],
  logo: { src: '', fallback: '' },
  background: { src: '', fallback: '' }
});

export const initialEmployee = (): Employee => ({
  uuid: '',
  app_avatar: { src: '', fallback: '' },
  translations: {},
  url: '',
  link: '',
  tips: ''
});

export const initialMenu = (): Menu => ({
  id: '',
  type: 'file',
  translations: {},
  menu_items: []
});

export const initialReview = (): Review => ({
  uuid: '',
  hash: '',
  reviewId: -1,
  rating: -1,
  photo: null,
  body: '',
  name: '',
  phone: '',
  state: 'first',
  ratingIncreaseStrategy: false,
  additionalQuestions: [],
  sending: false,
  ratingError: false,
  contacts_required: 'flexible'
});
